'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCropper = require('react-cropper');

var _reactCropper2 = _interopRequireDefault(_reactCropper);

var _View2 = require('../view/View');

var _View3 = _interopRequireDefault(_View2);

require('cropperjs/dist/cropper.css');

require('../../assets/css/components/button/UploadCroppedImage.css');

var _semanticUiReact = require('semantic-ui-react');

var _ButtonFields = require('../../components/form/ButtonFields');

var _ButtonFields2 = _interopRequireDefault(_ButtonFields);

var _Fields = require('../form/Fields');

var _Fields2 = _interopRequireDefault(_Fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadCroppedImage = function (_View) {
    _inherits(UploadCroppedImage, _View);

    function UploadCroppedImage(props) {
        _classCallCheck(this, UploadCroppedImage);

        var _this = _possibleConstructorReturn(this, (UploadCroppedImage.__proto__ || Object.getPrototypeOf(UploadCroppedImage)).call(this, props));

        _this.b64toBlob = function (b64Data) {
            var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        };

        _this.onClick = function (e) {
            e.preventDefault();
            if (!_this.state.result64 && !_this.state.urlPreview) {
                document.getElementById("file-" + _this.state.inputKey).click();
                _this.getDocumentName();
            } else {
                _this.onClearImage();
            }
        };

        _this.onInputClick = function (e) {
            e.preventDefault();
            if (!_this.state.result64 && !_this.state.urlPreview) {
                document.getElementById("file-" + _this.state.inputKey).click();
                _this.getDocumentName();
            }
        };

        _this.imagePreview = function () {
            return _react2.default.createElement(
                'div',
                { className: "img-preview-container" },
                _this.props.preview && _this.state.result64 ? _react2.default.createElement('img', { id: 'img-preview', className: "img-preview", src: _this.state.result64, role: 'presentation' }) : _this.props.preview && _this.state.urlPreview ? _react2.default.createElement('img', { id: 'img-preview', className: "img-preview", src: _this.state.urlPreview, role: 'presentation' }) : _react2.default.createElement('img', { id: 'img-preview', className: "img-preview", src: ' ', role: 'presentation' })
            );
        };

        _this.reOpen = function (e) {
            e.preventDefault();
            _this.props.setModalConfig("Visualizar Imagem Recortada", _this.props.descriptionModal || "", _this.imagePreview());
        };

        _this.state = {
            src: '',
            result64: null,
            urlPreview: null,
            inputKey: '',
            filename: ''
        };
        _this.cropImage = _this.cropImage.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onClearImage = _this.onClearImage.bind(_this);
        return _this;
    }

    _createClass(UploadCroppedImage, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.initPreview(nextProps.hasPreview);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.initPreview(this.props.hasPreview);
        }
    }, {
        key: 'initPreview',
        value: function initPreview(data) {
            var previewType = this.getPreviewType(data);
            if (previewType === 'b64') this.setState({ urlPreview: data });else if (previewType === 'url') this.setState({ result64: data });

            if (data && this.props.preview && (this.state.result64 || this.state.urlPreview)) {
                this.setState({ filename: "imagem.png" });
            }
        }
    }, {
        key: 'getPreviewType',
        value: function getPreviewType(data) {
            if (data) {
                var meta = data.substring(0, 5);
                if (meta === 'data:') return 'b64';else return 'url';
            }

            return null;
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var _this2 = this;

            e.preventDefault();
            var files = void 0;
            if (e.dataTransfer) {
                files = e.dataTransfer.files;
            } else if (e.target) {
                files = e.target.files;
            }

            this.setState({ files: files });

            var reader = new FileReader();
            reader.onload = function () {
                _this2.setState({ src: reader.result });
                _this2.props.setModalConfig(_this2.props.tituloModal, _this2.props.descriptionModal || "", _this2.getDialog(), _this2.cropImage);
            };
            reader.readAsDataURL(files[0]);
        }
    }, {
        key: 'cropImage',
        value: function cropImage() {
            if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
                return;
            }
            var width = this.props.width || 354;
            var height = this.props.height || 472;
            var base64 = this.cropper.getCroppedCanvas({ width: width, height: height }).toDataURL();
            var contentType = 'image/png';
            var b64Data = base64.split("data:image/png;base64,")[1];
            var imagemBlob = this.b64toBlob(b64Data, contentType);
            var arquivo = new FormData();
            arquivo.append('file', imagemBlob, this.props.fileName + '.png');
            this.props.getImageAction(arquivo, base64);
            this.setState({
                result64: base64
            });
        }
    }, {
        key: 'getDialog',
        value: function getDialog() {
            var _this3 = this;

            var _props = this.props,
                ratioX = _props.ratioX,
                ratioY = _props.ratioY;

            return _react2.default.createElement(
                'div',
                { className: 'upload-imagem' },
                _react2.default.createElement(
                    'div',
                    { className: 'cropper-area' },
                    _react2.default.createElement(_reactCropper2.default, {
                        aspectRatio: ratioX / ratioY,
                        preview: '.img-preview',
                        guides: false,
                        viewMode: 2,
                        src: this.state.src,
                        ref: function ref(cropper) {
                            _this3.cropper = cropper;
                        }
                    })
                )
            );
        }
    }, {
        key: 'onClearImage',
        value: function onClearImage() {
            var randomString = Math.random().toString(36);
            // document.getElementById("img-preview").removeAttribute("style")
            this.props.getImageAction(null);
            this.setState({
                inputKey: randomString, filename: '', result64: null, urlPreview: null
            });
        }
    }, {
        key: 'getDocumentName',
        value: function getDocumentName() {
            var that = this;
            var inputs = document.querySelectorAll('.input-file-hidden');
            Array.prototype.forEach.call(inputs, function (input) {
                input.addEventListener('change', function (e) {
                    var fileName = e.target.value.split('\\').pop();
                    if (fileName) that.setState({ filename: fileName });
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _Fields2.default,
                this.props,
                _react2.default.createElement('input', { tabIndex: '-1', id: "file-" + this.state.inputKey, key: "key-" + this.state.inputKey, className: "input-file-hidden", type: 'file', onChange: this.onChange, required: this.props.required, disabled: this.state.result64 || this.state.urlPreview, accept: 'image/*' }),
                _react2.default.createElement(
                    'div',
                    { className: "input-file-container" },
                    _react2.default.createElement(
                        'div',
                        { className: "flex-file-container" },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_semanticUiReact.Input, { tabIndex: '-1', className: 'md-input border-bottom-primary', onFocus: this.onInputClick, value: this.state.filename, placeholder: 'Selecione uma imagem' }),
                            this.props.preview && (this.state.result64 || this.state.urlPreview) ? _react2.default.createElement(
                                'div',
                                { className: 'actions-icon' },
                                _react2.default.createElement(_ButtonFields2.default, { type: 'button', button: 'fab', icon: 'remove_red_eye', title: 'Visualizar', mini: true, color: 'transparent', onClick: this.reOpen }),
                                _react2.default.createElement(_ButtonFields2.default, { type: 'button', button: 'fab', icon: 'close', mini: true, title: "Limpar", color: 'transparent', onClick: this.onClick })
                            ) : null
                        ),
                        _react2.default.createElement(_ButtonFields2.default, { onClick: this.onClick, button: 'colored', content: "Escolher", disabled: this.state.result64 || this.state.urlPreview })
                    )
                )
            );
        }
    }]);

    return UploadCroppedImage;
}(_View3.default);

exports.default = UploadCroppedImage;


UploadCroppedImage.propTypes = {
    setModalConfig: _propTypes2.default.func.isRequired,
    getImageAction: _propTypes2.default.func.isRequired,
    tituloModal: _propTypes2.default.string.isRequired,
    descriptionModal: _propTypes2.default.string,
    fileName: _propTypes2.default.string.isRequired,
    hasPreview: _propTypes2.default.string,
    ratioX: _propTypes2.default.number.isRequired,
    ratioY: _propTypes2.default.number.isRequired,
    preview: _propTypes2.default.bool,
    required: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/button/UploadCroppedImage.js
// module id = 1103
// module chunks = 0